import { rgba, Tooltip } from '@mantine/core';
import dayjs from 'dayjs';

import classes from './timeline-bar.module.css';
import { TimelineItem } from './types';
import { getWeekOffset, WEEK_WIDTH, DAY_WIDTH } from './utils';

interface TimelineBarProps {
  timeline: TimelineItem;
  minDate: Date;
}

export function TimelineBar({ timeline, minDate }: TimelineBarProps) {
  const startDate = new Date(timeline.start_date);
  const endDate = new Date(timeline.end_date);

  // Calculate week offset and position
  const startWeekOffset = getWeekOffset(startDate, minDate);
  const duration = dayjs(endDate).diff(dayjs(startDate), 'day') + 1;

  // Position within the week column based on actual dates
  const startDayInWeek =
    dayjs(startDate).diff(dayjs(minDate), 'day') - startWeekOffset * 7;
  const leftPosition =
    startWeekOffset * WEEK_WIDTH + startDayInWeek * DAY_WIDTH;
  const width = Math.max(duration * DAY_WIDTH, 8); // Minimum width for visibility

  return (
    <Tooltip
      label={`${timeline.name}: ${dayjs(startDate).format('MMM DD')} - ${dayjs(endDate).format('MMM DD')}`}
      position="top"
    >
      <div
        className={classes.bar}
        style={
          {
            left: `${leftPosition}px`,
            width: `${width}px`,
            backgroundColor: timeline.outline
              ? rgba(timeline.color, 0.25)
              : timeline.color,
            border: timeline.outline
              ? `4px solid ${timeline.color}`
              : undefined,
            '--scale-factor': timeline.scale_factor,
            zIndex: timeline.z_index ?? 10,
          } as React.CSSProperties & Record<string, any>
        }
      />
    </Tooltip>
  );
}
